import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import SpriteComponent from '../../../Component/Render/Sprite';
import Game from '../../../Game';

export class ZapChunkLoop extends AnimationClip {
    private frames: string[];
    private zapSprite: SpriteComponent;
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        this.frames = [
            'ZapCard_LightningVFX0001',
            'ZapCard_LightningVFX0002',
            'ZapCard_LightningVFX0003',
            'ZapCard_LightningVFX0004',
        ];
        this.zapSprite = gameObject.getComponent(SpriteComponent);
    }

    public update(): void {
        const elapsedTime = Game.ticker.getElapsedTime();
        const frame = Math.floor(elapsedTime / 60) % this.frames.length;
        this.zapSprite.texture = this.frames[frame];
    }
}
